export enum HttpMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Delete = 'DELETE',
  Patch = 'PATCH',
}
export type Body = ArrayBuffer | string

export type RequestData = {
  method: HttpMethod
  endpoint: string
  json?: object
  body?: Body
  query?: object
}
export enum StatusCode {
  NoContent = 204,
  Unauthorized = 401,
  Forbidden = 403,
}

export class ResponseError extends Error {
  originalResponse: Partial<Response>
  errorMessage: string
  /**
   * Creates a new response error that contains the original
   * http response along with the error when it's thrown
   * @param error the error thrown
   * @param originalResponse the original http response
   */
  constructor(error: Error, originalResponse: Partial<Response>) {
    super(error.message)
    this.errorMessage = error.message
    this.originalResponse = originalResponse
  }
}

export const HttpError = {
  Unauthorized: new Error('Unauthorized'),
  Forbidden: new Error('Forbidden'),
  Server: new Error('There was problem communicating with our servers, please try again later.'),
  NoInternet: new Error('No internet connection could be found.'),
}
